import cssVariables from 'src/common/styles/variables';

/*
#7FCFEC Sky
#D24A7A Pink
#FEC25A Gold
#FD685F Coral
#DFC596 Tan
#14D8CC T-Sharp
*/
export const validColorsArr = [
  cssVariables['--sky'],
  '#D24A7A',
  '#FEC25A',
  cssVariables['--tunein-coral'],
  '#DFC596',
  cssVariables['--t-sharp'],
  cssVariables['--black'],
];

export const CAROUSEL_FETCH_SKIP_MSG = 'heroCarousel.fetched.false';
export const CAROUSEL_GUIDEID = 'landing';
export const CAROUSEL_UPSELL_GUIDEID = 'c100000260';
